/** League fight reminders by Web Push as a switch (Settings, the reminders sheet, the fight cards): state and toggling. */
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { disablePush, enablePush, pushAvailability, pushEnabled, type PushAvailability, type PushResult } from '../platform/push';

/** Told when reminders are turned on or off here, so every switch and card shows the same. */
const CHANGED = 'caged:push-changed';

export function usePush() {
  const { i18n } = useTranslation();
  const [availability] = useState<PushAvailability>(() => pushAvailability());
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [problem, setProblem] = useState<PushResult | null>(null);
  useEffect(() => {
    let alive = true;
    const check = () => void pushEnabled().then((on) => alive && setEnabled(on));
    check();
    window.addEventListener(CHANGED, check);
    return () => {
      alive = false;
      window.removeEventListener(CHANGED, check);
    };
  }, []);
  const set = useCallback(
    async (on: boolean) => {
      setBusy(true);
      setProblem(null);
      if (on) {
        const r = await enablePush(i18n.language);
        setEnabled(r === 'on');
        if (r !== 'on') setProblem(r);
      } else {
        await disablePush();
        setEnabled(false);
      }
      setBusy(false);
      window.dispatchEvent(new Event(CHANGED));
    },
    [i18n.language],
  );
  return { availability, enabled, busy, problem, set };
}
